// Environment configurations
const ENV = {
  LOCAL: {
    API_BASE_URL: 'http://localhost:8080',
    // Square SDK Configuration (Sandbox)
    SQUARE_APPLICATION_ID: process.env.REACT_APP_SQUARE_APPLICATION_ID || 'sandbox-sq0idb-Rf2Iz7CZYs4F07dYgB6xtw',
    SQUARE_LOCATION_ID: process.env.REACT_APP_SQUARE_LOCATION_ID || 'L79M484XQP56Z',
    // Google reCAPTCHA Configuration
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdklnsrAAAAAGIjcFntkR0MzIZo5buVzZO5DnP5', // Test key for reCAPTCHA v2
    // Google Maps API Key (for Places UI Kit - OPTIONAL)
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY || '', // Set in .env.local if using Places UI Kit
  },
  STAGING: {
    // Use a relative URL that will inherit the protocol from the frontend
    API_BASE_URL: 'https://staging.equipovisionint.com',
    // Square SDK Configuration (Production or Staging)
    SQUARE_APPLICATION_ID: process.env.REACT_APP_SQUARE_APPLICATION_ID || 'sq0idp-twy8StDRfaPf3PAw4ONwJg',
    SQUARE_LOCATION_ID: process.env.REACT_APP_SQUARE_LOCATION_ID || 'LJHSS8R5JS3PN',
    // Google reCAPTCHA Configuration
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdklnsrAAAAAGIjcFntkR0MzIZo5buVzZO5DnP5', // Test key for reCAPTCHA v2
    // Google Maps API Key (for Places UI Kit - OPTIONAL)
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY || '', // Set in .env.local if using Places UI Kit
  },
  TESTING: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api-test.ibohq.com',
    SQUARE_APPLICATION_ID: process.env.REACT_APP_SQUARE_APPLICATION_ID || 'sandbox-sq0idb-Rf2Iz7CZYs4F07dYgB6xtw',
    SQUARE_LOCATION_ID: process.env.REACT_APP_SQUARE_LOCATION_ID || 'L79M484XQP56Z',
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdklnsrAAAAAGIjcFntkR0MzIZo5buVzZO5DnP5',
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY || '',
  },
  PRODUCTION: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.ibohq.com',
    SQUARE_APPLICATION_ID: process.env.REACT_APP_SQUARE_APPLICATION_ID,
    SQUARE_LOCATION_ID: process.env.REACT_APP_SQUARE_LOCATION_ID,
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY,
  }
};

// Determine which environment to use
// You can change this to 'STAGING' to use staging environment
const CURRENT_ENV = process.env.REACT_APP_ENV || 'LOCAL';

// Export the configuration for the current environment
const config = ENV[CURRENT_ENV];

// Fallback to LOCAL if config is undefined
const finalConfig = config || ENV.LOCAL;

if (!config) {
  console.warn(`Environment '${CURRENT_ENV}' not found, falling back to LOCAL environment`);
}


export default finalConfig; 